import * as Sentry from '@sentry/react';
import {
	GetAccountOrgsResponse,
	GetAdminhubAccountOrgsResponse,
} from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';
import { checkFeatureFlagGate } from '@wac-web/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@wac-web/utils/feature-flags/feature-flag-manifest';

import { SENTRY_PROJECT_NAME } from '../constants';

import type { FastShiftState } from './reducer';

// accountOrgs contains active and inactive orgs (due to a server-side bug)
// adminhubAccountOrgs contains only active orgs, but not whether the user is an org admin
// we can find active orgs while preserving org admin field by returning common items
export const filterForActiveOrgs = (
	accountOrgs: GetAccountOrgsResponse['accountOrgs'],
	adminhubAccountOrgs: GetAdminhubAccountOrgsResponse['accountOrgs'],
): GetAccountOrgsResponse['accountOrgs'] => {
	if (!accountOrgs || !adminhubAccountOrgs) {
		return [];
	}

	const mergedAccountOrgs = accountOrgs.filter((org) => {
		return adminhubAccountOrgs?.find((adminhubOrg) => adminhubOrg.id === org.id);
	});

	return mergedAccountOrgs;
};

export const getUserDomain = (state: FastShiftState) => {
	const isGeneralAccessEnabled = checkFeatureFlagGate(featureFlags.sxpFastshiftEnableGeneralAccess);

	return isGeneralAccessEnabled
		? state.userAccess.data?.userDomain?.domain
		: state.userDetails.data?.userDomain?.domain;
};

export const captureErrorWithContext = ({
	error,
	message,
	userDomain,
}: {
	error: string;
	message: string;
	userDomain?: string;
}) => {
	Sentry.captureException(new Error(error), {
		tags: {
			projectName: SENTRY_PROJECT_NAME,
		},
		extra: {
			errorMessage: message,
			userDomain: userDomain || '',
		},
	});
};

export const getRunbookStepActionKey = ({
	runbookId,
	stepId,
}: {
	runbookId: string;
	stepId: string;
}) => `${runbookId}:${stepId}`;
